import request from "@/service";

/* 查询配置列表 */
export function configInfoList(data) {
  return request({
    url: "/resource/config/info/page",
    method: "get",
    params: data
  });
}

/* 查询资源---配置中心 */
export function findResourcesList(data) {
  return request({
    url: `/resource/config/info/findResourcesList`,
    method: "get",
    params: data
  });
}

/* 查询资源---专题管理 */
export function findSubjectResources(data) {
  return request({
    url: `/resource/config/info/findSubjectResources`,
    method: "get",
    params: data
  });
}

/* 查询已关联资源 */
export function findRelationResourcesList(bizType) {
  return request({
    url: `/resource/config/info/findRelationResourcesList/${bizType}`,
    method: "get"
  });
}

/* 批量删除配置 */
export function configInfoDelete(data) {
  return request({
    url: "/resource/config/info/delete",
    method: "delete",
    data
  });
}

/* 新增 */
export function configInfoSave(data) {
  return request({
    url: `/resource/config/info/save`,
    method: "post",
    data
  });
}

/* 最新最热设置和取消 */
export function setNewAndHot(data) {
  return request({
    url: "/resource/config/info/setNewAndHot",
    method: "post",
    data
  });
}

/* 拖拽排序 */
export function updateOrderByDrag(data) {
  return request({
    url: "/resource/config/info/updateOrderByDrag",
    method: "put",
    data
  });
}
